import React from "react";
import settings from "../settings";

function Logo({
  dark = false,
  style = {},
  showImageOnly = false,
  className = "",
}) {
  return showImageOnly ? (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <img
        src={process.env.PUBLIC_URL + "/logo512.png"}
        alt="Logo"
        style={{
          maxHeight: "100px",
          margin: "30 auto",
          ...style,
        }}
      />
    </div>
  ) : (
    <div
      className={className}
      style={{
        fontFamily: "Lexend Deca variant0, sans-serif",
        fontSize: "24px",
        fontWeight: 900,
        color: "var(--text-color)",
        textAlign: "center",
        padding: "16px",
        ...style,
      }}
    >
      VALUE DRAW
    </div>
  );
}

export default Logo;
